import { render, staticRenderFns } from "./service-detail.vue?vue&type=template&id=11548937&scoped=true&lang=pug"
import script from "./service-detail.vue?vue&type=script&lang=js"
export * from "./service-detail.vue?vue&type=script&lang=js"
import style0 from "./service-detail.vue?vue&type=style&index=0&id=11548937&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11548937",
  null
  
)

export default component.exports